import React from 'react';

interface LoadingSkeletonProps {
  className?: string;
}

const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({ className = 'h-20' }) => {
  return (
    <div className={`animate-pulse bg-white rounded-lg ${className}`}>
      <div className="h-full w-full rounded-lg shimmer"></div>
    </div>
  );
};

export default LoadingSkeleton;